"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenReplacementStore = void 0;
var mobx_1 = require("mobx");
var FetchUtils_1 = require("@CommonFrontendBackend/Utils/FetchUtils");
var TokenApiErrors_1 = require("Project/Actions/Tokens/Common/TokenApiErrors");
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var Types_2 = require("Tokens/Types");
var BlockTokenTraverser_1 = require("@CommonFrontendBackend/Blocks/BlockTokenTraverser");
var TokenReplacerService_1 = __importDefault(require("Project/Actions/Tokens/Stores/TokenReplacementStore/Replacers/TokenReplacerService"));
var VariableTokenReplacer_1 = __importDefault(require("Project/Actions/Tokens/Stores/TokenReplacementStore/Replacers/VariableTokenReplacer"));
var ButtonTokenReplacer_1 = __importDefault(require("Project/Actions/Tokens/Stores/TokenReplacementStore/Replacers/ButtonTokenReplacer"));
var MediaVariableTokenReplacer_1 = __importDefault(require("Project/Actions/Tokens/Stores/TokenReplacementStore/Replacers/MediaVariableTokenReplacer"));
var TelemetryTypes_1 = require("@CommonFrontendBackend/Tokens/TelemetryTypes");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var Types_3 = require("@CommonFrontendBackend/QuoteV2/Types");
var Section_1 = require("QuoteV2/Models/Section");
var TokenReplacementStore = (function () {
    function TokenReplacementStore(projectStore, project, tokenApiService, telemetry) {
        var _this = this;
        this.projectStore = projectStore;
        this.project = project;
        this.tokenApiService = tokenApiService;
        this.telemetry = telemetry;
        this.tokenIndexMap = new Map();
        this.tokenSearchResults = { status: FetchUtils_1.RemoteDataStatus.NotRequested };
        this.fetchedCurrentSubstitutionTokens = [];
        this.hasFetchedCurrentSubstitutionTokens = false;
        this.hasProductTokens = false;
        this.selectedProvider = null;
        this.selectedCrmObject = null;
        this.getNewIndex = function (currentIndex) {
            var _a;
            return (_a = _this.getNewToken(currentIndex)) === null || _a === void 0 ? void 0 : _a.index;
        };
        this.getNewToken = function (currentIndex) {
            return (0, mobx_1.computed)(function () {
                if (currentIndex == null || !_this.tokenIndexMap.has(currentIndex)) {
                    return null;
                }
                var tokenHolder = _this.tokenIndexMap.get(currentIndex);
                if ((0, Types_2.isToken)(tokenHolder) && !!tokenHolder.id) {
                    return {
                        index: tokenHolder.id,
                        apiName: tokenHolder.apiName,
                        name: tokenHolder.name,
                    };
                }
                else {
                    return {
                        index: tokenHolder.apiName,
                        apiName: tokenHolder.apiName,
                        name: tokenHolder.name,
                    };
                }
            }).get();
        };
        this.updateProjectCrmInfo = function () { return __awaiter(_this, void 0, void 0, function () {
            var info, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        info = {
                            connected: true,
                            integration: this.selectedProvider,
                            object: this.selectedCrmObject,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.projectStore.setCrmInfo(info)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        throw e_1;
                    case 4: return [2];
                }
            });
        }); };
        this.searchTokens = function (searchTerm) { return __awaiter(_this, void 0, Promise, function () {
            var searchResult, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.selectedProvider == null || this.selectedCrmObject == null) {
                            throw new Error("Trying to search tokens without a selected provider or object");
                        }
                        this.setTokenSearchResults({ status: FetchUtils_1.RemoteDataStatus.Loading });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.tokenApiService.fetchTokens({
                                providerType: this.selectedProvider,
                                objectType: this.selectedCrmObject,
                                query: searchTerm,
                            })];
                    case 2:
                        searchResult = _a.sent();
                        this.setTokenSearchResults({
                            status: FetchUtils_1.RemoteDataStatus.Success,
                            data: searchResult.filter(function (result) { return result.dataType !== Types_1.TokenDataType.ProductList; }),
                        });
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.setTokenSearchResults({
                            status: FetchUtils_1.RemoteDataStatus.Error,
                            error: new Error((0, TokenApiErrors_1.getFetchTokensErrorMessage)(error_1)),
                        });
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        this.setTokenSearchResults = function (data) {
            _this.tokenSearchResults = data;
        };
        this.setProviderType = function (providerType) {
            _this.selectedProvider = providerType;
        };
        this.setCrmObject = function (crmObject) {
            _this.selectedCrmObject = crmObject;
        };
        this.setFetchedCurrentSubstitutionTokens = function (tokens) {
            _this.fetchedCurrentSubstitutionTokens = tokens;
        };
        this.setHasFetchedCurrentSubstitutionTokens = function (value) {
            _this.hasFetchedCurrentSubstitutionTokens = value;
        };
        this.setHasProductTokens = function (hasProductTokens) {
            _this.hasProductTokens = hasProductTokens;
        };
        this.getCurrentSubstitutionTokensFromTemplate = function () { return __awaiter(_this, void 0, Promise, function () {
            var allTokens, replacementTokens;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setHasFetchedCurrentSubstitutionTokens(false);
                        return [4, this.tokenApiService.getTokensFromTemplate(this.project._id)];
                    case 1:
                        allTokens = _a.sent();
                        replacementTokens = allTokens
                            .filter(function (t) { return !(t.apiName === Types_1.ProductToken && _this.projectStore.isCrmTemplate); })
                            .map(function (nestedToken) {
                            return { index: nestedToken.id || nestedToken.apiName, apiName: nestedToken.apiName, name: nestedToken.name };
                        });
                        this.setFetchedCurrentSubstitutionTokens(replacementTokens);
                        this.setHasProductTokens(allTokens.length > replacementTokens.length);
                        this.setHasFetchedCurrentSubstitutionTokens(true);
                        return [2];
                }
            });
        }); };
        this.clearTokenReplacementSelections = function () {
            _this.tokenIndexMap.clear();
        };
        this.blockTokenTraverser = new BlockTokenTraverser_1.BlockTokenTraverser();
        this.tokenReplacerService = new TokenReplacerService_1.default([
            new VariableTokenReplacer_1.default(),
            new ButtonTokenReplacer_1.default(),
            new MediaVariableTokenReplacer_1.default(),
        ]);
    }
    TokenReplacementStore.prototype.replaceTokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.project.blocks.length === 0) {
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4, this.updateProjectCrmInfo()];
                    case 2:
                        _a.sent();
                        return [4, this.updateTokens()];
                    case 3:
                        _a.sent();
                        this.telemetry.track(TelemetryTypes_1.TokensEvents.TokenSwapSubmitted, {}, { blockIntercom: true });
                        return [3, 5];
                    case 4:
                        error_2 = _a.sent();
                        throw error_2;
                    case 5:
                        this.clearTokenReplacementSelections();
                        return [2];
                }
            });
        });
    };
    TokenReplacementStore.prototype.updateTokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.project.blocks.forEach(function (block) {
                    if (block.type === BlockTypes_1.BlockType.Quote) {
                        block.sections.forEach(function (s) {
                            s.items = (0, Section_1.QuoteItems)(s.items.filter(function (lineItem) { return lineItem.type !== Types_3.QuoteItemType.Product; }));
                        });
                    }
                    _this.blockTokenTraverser.processAndTransformTokens(block, function (contentToken) {
                        return _this.tokenReplacerService.processToken(contentToken, _this.tokenIndexMap);
                    });
                });
                this.reloadBlocksContent();
                return [2];
            });
        });
    };
    TokenReplacementStore.prototype.reloadBlocksContent = function () {
        this.project.blocks.forEach(function (block) {
            if (!!block.$triggerLoad) {
                block.$triggerLoad();
            }
        });
    };
    Object.defineProperty(TokenReplacementStore.prototype, "currentSubstitutionTokens", {
        get: function () {
            return this.fetchedCurrentSubstitutionTokens;
        },
        enumerable: false,
        configurable: true
    });
    TokenReplacementStore.prototype.updateTokenMap = function (currentIndex, newReplaceToken) {
        this.tokenIndexMap.set(currentIndex, newReplaceToken);
    };
    Object.defineProperty(TokenReplacementStore.prototype, "providerType", {
        get: function () {
            return this.selectedProvider;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenReplacementStore.prototype, "projectId", {
        get: function () {
            return this.project._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenReplacementStore.prototype, "crmObjectType", {
        get: function () {
            return this.selectedCrmObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenReplacementStore.prototype, "countTokens", {
        get: function () {
            return this.fetchedCurrentSubstitutionTokens.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenReplacementStore.prototype, "hasTokens", {
        get: function () {
            return this.fetchedCurrentSubstitutionTokens.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenReplacementStore.prototype, "hasFinishedFetchingCurrentSubstitutionTokens", {
        get: function () {
            return this.hasFetchedCurrentSubstitutionTokens;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenReplacementStore.prototype, "doAllTokensHaveReplacement", {
        get: function () {
            return this.tokenIndexMap.size === this.fetchedCurrentSubstitutionTokens.length;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], TokenReplacementStore.prototype, "tokenIndexMap", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof FetchUtils_1.RemoteData !== "undefined" && FetchUtils_1.RemoteData) === "function" ? _a : Object)
    ], TokenReplacementStore.prototype, "tokenSearchResults", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], TokenReplacementStore.prototype, "fetchedCurrentSubstitutionTokens", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], TokenReplacementStore.prototype, "hasFetchedCurrentSubstitutionTokens", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], TokenReplacementStore.prototype, "hasProductTokens", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], TokenReplacementStore.prototype, "selectedProvider", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], TokenReplacementStore.prototype, "selectedCrmObject", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], TokenReplacementStore.prototype, "replaceTokens", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], TokenReplacementStore.prototype, "currentSubstitutionTokens", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", void 0)
    ], TokenReplacementStore.prototype, "updateTokenMap", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenReplacementStore.prototype, "searchTokens", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenReplacementStore.prototype, "setTokenSearchResults", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenReplacementStore.prototype, "setProviderType", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenReplacementStore.prototype, "setCrmObject", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], TokenReplacementStore.prototype, "providerType", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], TokenReplacementStore.prototype, "projectId", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], TokenReplacementStore.prototype, "crmObjectType", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], TokenReplacementStore.prototype, "countTokens", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TokenReplacementStore.prototype, "hasTokens", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TokenReplacementStore.prototype, "hasFinishedFetchingCurrentSubstitutionTokens", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TokenReplacementStore.prototype, "doAllTokensHaveReplacement", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenReplacementStore.prototype, "setFetchedCurrentSubstitutionTokens", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenReplacementStore.prototype, "setHasFetchedCurrentSubstitutionTokens", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenReplacementStore.prototype, "setHasProductTokens", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenReplacementStore.prototype, "getCurrentSubstitutionTokensFromTemplate", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenReplacementStore.prototype, "clearTokenReplacementSelections", void 0);
    return TokenReplacementStore;
}());
exports.TokenReplacementStore = TokenReplacementStore;
